/**
 * ToggleAnimate
 * @class
 */
class ToggleAnimate {

  /**
   * @static
   */
  static get defOpts() {
    return {
      $el     : null,
      anime   : [{},{}],
      showType: 'display',  // [display | visibility | null]
      opts    : {},
    }
  }

  /**
   * @param _opts {object} css or anime taype and velocity options
   */
  constructor(_opts = {}) {
    const { $el, anime, showType, opts } = _.defaults(_opts, ToggleAnimate.defOpts);

    this.$el      = $el;
    this.anime    = anime;
    this.showType = showType;
    this.opts     = opts;
  }

  /**
   * @param _toggle {boolean} display set show or hide
   * @param _opts {object} veloctiy optoins
   */
  run(_toggle, _opts = {}) {
    const defOpts_ = {
      $el  : this.$el,
      opts : this.opts,
      anime: (_toggle ? this.anime[0] : this.anime[1]),
    }

    const { $el, anime, opts } = _.defaultsDeep(_opts, defOpts_);

    const opts_ = _.clone(opts);

    if(typeof anime !== 'string') {
      switch(this.showType) {
        case 'display':
          opts_.display = _toggle ? 'block' : 'none';
          break;
        case 'visibility':
          opts_.visibility = _toggle ? 'visible' : 'hidden';
          break;
      }
    }

    Velocity($el, 'stop');
    Velocity($el, anime, opts_);
  }

}

/**
 * class exports
 */
module.exports = ToggleAnimate;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/velocity/toggle-animate.js
 **/